import React from 'react';
import { useAppSelector } from '../app/hooks';
import getThemeLookup from '../selectors/getThemeLookup';
import { CONTAINER_PROPERTIES } from '../utils/theme';

interface PillProps {
  value?: string;
  isActive?: boolean;
  onClick?: () => void;
  icon?: JSX.Element;
}

export const Pill = ({ value, isActive, onClick, icon }: PillProps) => {
  const p = useAppSelector(getThemeLookup);

  return (
    <div style={styles.container}>
      <div
        style={{
          ...styles.pill,
          ...p('pill', CONTAINER_PROPERTIES),
          ...(isActive && p('pillActive', ['border', 'backgroundColor'])),
        }}
        onClick={onClick}
      >
        {icon && (
          <span style={{ ...styles.icon, ...(isActive && p('pillIconActive', ['color'])) }}>
            {icon}
          </span>
        )}
        <span
          style={{
            ...p('pillText', ['fontSize']),
            ...(isActive && p('pillTextActive', ['color'])),
          }}
        >
          {value}
        </span>
      </div>
    </div>
  );
};

const styles: Styles = {
  container: {
    display: 'flex',
  },
  pill: {
    borderRadius: 20,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    cursor: 'pointer',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  icon: {
    marginRight: 5,
    display: 'flex',
    alignItems: 'center',
  },
};
